
Checkout.Suggestions = function(checkout) {
    var suggestions = this;

    suggestions.items = {};
    suggestions.sections = [];
    suggestions.$modal = false;
    suggestions.defaultSuggestionTitle = false;
    suggestions.addedToModal = false;

    suggestions.init = function() {
        suggestions.$modal = $("#suggestions");
        suggestions.defaultSuggestionTitle = suggestions.$modal.find(".defaultSuggestionTitle").val();
        suggestions.listen();
    };

    suggestions.listen = function() {
		$('#suggestions.modal').on('shown.bs.modal', function(){
			if(pointsBreak.getWidth() > 480){ suggestionItemHeights(); }
			$('#suggestions').removeClass('notShown');
		});
        checkout.cart.$showSuggestions.click(suggestions.show);
    };

    // Prepare and display the modal dialog with the suggestions
    suggestions.show = function() {
        // Only show the suggestions if there are some to show
        if(! Object.keys(suggestions.items).length) return;

        //!(seen === Object.keys(checkout.suggestions.items).length)
        // If we've seen all of the items, don't popover
        if(suggestions.addToModal() && !suggestions.seenStatus(seenSuggestions)) {
           	// Only show the dialog if we added something to it
           	suggestions.$modal.modal("show");

            var prodCont = $('#suggestions .product-container').not('.product-container.hide'),
              prodContLen = prodCont.length,
              theContainer = $('#suggestions');
            prodContLen > 2 ? (prodContLen > 3 ? theContainer.addClass('gtTre') : theContainer.addClass('tre')) :
              (prodContLen < 2 ? theContainer.addClass('uno') : theContainer.addClass('deuce'));
        }
    };

	suggestions.seenStatus = function(hasSeen) {
		// If we've already 'seen' the modal, set false to allow us to click it
		if(hasSeen) {
			return false;
		}

		// Check the seen status of all parts, if we've seen all of them then don't
		// load on loading of the cart
		var seen = 0;
		for ( var suggestion in suggestions.items ) {
			if ( suggestions.items[suggestion].seen === 1 ) {
				seen++;
			}
		}

		if ( seen === Object.keys(suggestions.items).length ) {
			return true;
		}
	};

    // Add the current list of products to the modal window
    suggestions.addToModal = function() {
        // Only add items once
        if(suggestions.addedToModal) return true;

        var validSuggestions = 0;
        for(var productID in suggestions.items) {
            if(suggestions.addProductToModal(suggestions.items[productID])) validSuggestions ++;
        }

        if(validSuggestions) {
            checkout.cart.$showSuggestions.find(".suggestionCount").html(validSuggestions);
            checkout.cart.$showSuggestions.removeClass("hide").show();
        }
        else {
            // Bail out now if there aren't any suggestions
            return false;
        }

        suggestions.addSectionsToModal();
        suggestions.addedToModal = true;
        return true;
    };

    // Add an individual product to the correct section,
    // along with any formatting
    suggestions.addProductToModal = function(item) {
        var $product = suggestions.$modal.find(".product-container.template").clone(),
            product = item.product;
        $product.removeClass("template hide");

        // Do not suggest items already seen
        if (item.seen)
            return false;

        // Do not suggest something already in the cart
        if(checkout.cart.containsProductID(product.productID))
            return false;

        // fields that go directly into the template
        var displayFields = [
            "clean_description2",
            "productID",
        ];
        for(var i = 0; i < displayFields.length; i ++) {
            var field = displayFields[i],
                $field = $product.find("." + field);
            $field.html(product[field]);
        }

        // Sale Discount
        var discount = 0;
        if(product.price_retail) {
            discount = (product.price_retail - product.unitprice) / product.price_retail;
        }
        if(discount > 0.01) {
            var $pricecut = $product.find(".pricecut"),
                $savings  = $product.find(".pricesave");
            $pricecut.html("$" + product.price_retail);
            $pricecut.show();

            if(discount > 0.10) {
                var percent = Math.round(discount * 100);
                $savings.html(
                    $("<span class='savings'>").html(
                        $("<span class='osale'>").html(
                            $("<span class='saleTxt'>").html("On Sale")
                        ).append(
                            $("<span class='percent'>").html("Save " + percent + "%")
                        )
                    )
                );
            }
            else {
                $savings.html("On SALE");
            }
            $savings.show();
        }

        $product.find(".price_retail").html("$" + product.unitprice);
        $product.find(".clean_description")
            .prop("href", product.canonicalPath)
            .html('<span class="prodTitle">' + product.clean_description + '</span><span class="ecsPartNumber">Part #: <u>' + product.productID + '</u></span>');
		$product.find(".brand-definition").html('Brand: <u>' + product.brand.name + '</u>');
        

        if(product.mainImage) {
	        var imageURL = CDNproduct + "/" + product.mainImage + "_x300.jpg";
            $product.find("img.productImage").prop("src", imageURL);
        }
		
		//$product.find(".stockstatus-icon").addClass("status-"+product.stockStatusIcon);
		$product.find(".stockstatus-text").prepend('<span>'+product.stockStatus+'</span>');
		$product.find(".status_tooltip").attr('data-content', product.stockStatusLong);
		
		if (parseInt(product.shipfree || 0)) {
			var $shipfree = $product.find(".freeshipping");
			$shipfree.removeClass("hide");
			freeShippingPopup($shipfree);
		}
		else if (parseInt(product.shipFreeEligible || 0)) {
			var $freeshippingeligible = $product.find(".freeshippingeligible");
			$freeshippingeligible.removeClass("hide");
			freeShippingEligiblePopup($freeshippingeligible);
		}
		
        // Handlers for the add to cart/wl buttons
        $product.find("a.atc").click(function() {
            // If the browser supports it, change the
            // referer URL to show this as a suggestion
            if(window.history.replaceState) {
                window.history.replaceState({}, "", "./Suggestion/");
            }
            addToCart(product.productID);
            return false;
        });
        $product.find("a.atwl").click(function() {
            suggestions.$modal.modal("hide");
            addToWishList(product.productID);
            return false;
        });

        if(product.inWishList) {
            $product.find("a.atwl").addClass("added")
                .addClass("wl-" + product.inWishList);
        }

        // Actually add this into the section DOM
        var $section = suggestions.$modal.find('.section.template').clone().removeClass('template hide');
        $section.find(".products").append($product);
		suggestions.sections.push($section);
        return true;
    };

    // Insert the various sections into the modal dialog
    suggestions.addSectionsToModal = function(){
			for(var i = 0; i < suggestions.sections.length; i++){
				suggestions.$modal.find('.modal-body').append(suggestions.sections[i]);
      }
    };

    // Add a product to the suggestion list,
    // keyed by productID to prevent duplicates
    suggestions.addItem = function(item) {
        suggestions.items[item.product.productID] = item;
    };

    suggestions.init();
};

